export * from './PartnerService';
export * from './PartnerService.props';
